// Angular Imports
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoginResponse } from '@shared/models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _httpClient = inject(HttpClient);
  private _apiUrl = environment.apiUrl;

  login(
    formValue: Partial<{
      email: string | null;
      password: string | null;
    }>
  ): Observable<LoginResponse> {

	const adaptedValue = {
		email: formValue.email ?? '',
		password: formValue.password ?? ''
	}

    return this._httpClient.post<LoginResponse>(`${this._apiUrl}/api/login`, adaptedValue);
  }
}
